export const selectedSeatsSelector = state =>state.passengerFormReducer.selectedSeats;

export const passengerInfoSelector=state=>{
    return{
        emailId:state.passengerFormReducer.emailId,
        phoneNumber:state.passengerFormReducer.phoneNumber,
        boardingId:state.passengerFormReducer.boardingId,
        dropId:state.passengerFormReducer.dropId,
        selectedSeats:state.passengerFormReducer.selectedSeats,
        blockedSeatTicketId:state.passengerFormReducer.blockedSeatTicketId,
        timeOfRelease:state.passengerFormReducer.timeOfRelease,
        remarks:state.passengerFormReducer.remarks,
        selectedTripRoute:state.passengerFormReducer.selectedTripRoute,
        vipTicketReasons:state.passengerFormReducer.vipTicketReasons
    }
};

export const blockedSeatTicketIdSelector = state => state.passengerFormReducer.blockedSeatTicketId;

export const adminBlockTripRouteIdSelector = state => state.passengerFormReducer.adminBlockTripRouteId;

export const extraSeatInfoSelector = state=> {
    return {
        extraSeatCount: state.passengerFormReducer.extraSeatCount,
        extraSeatInfoList: state.passengerFormReducer.extraSeatInfoList
    }
}

export const hoverSeatTicketIdSelector = state => state.passengerFormReducer.hoverSeatTicketId;

export const expandedSharedSeatNumberSelector = state => state.passengerFormReducer.expandedSharedSeatNumber;

export const maxDiscountConfigSelector = state => state.passengerFormReducer.maxDiscountConfig;